/* eslint-disable */

/**
 * @note this file is auto-generated from running "npm run import-zebralist".
 * Please do not manually write to this file.
 */
export const ZEBRALIST = {
	"DYNAMIC": [
		"/unscramble/.+",
		"/quordle/.*",
		"/app/.*",
		"/scrabble-dictionary/.+",
		"/anagram-solver/.+",
		"/4pics1word/.+",
		"/wordle/results/.*"
	],
	"STATIC": [
		"/game-cheats/",
		"/popular-pages/",
		"/top-searched-word-combos/",
		"/top-unscrambles/",
		"/about/",
		"/search/",
		"/saved-words/",
		"/ltk-control-room/",
		"/feature-toggling/",
		"/wordle/",
		"/wordle/answers/",
		"/wordle/hints/"
	]
};
